import React from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useMsal } from "@azure/msal-react";
import { getUserDisplayName, getUserEmail } from "../utils/authUtils";
import { getPreferredMsalAccount } from "../utils/msalAccountUtils";

export const UnauthorizedPage: React.FC = () => {
  const { accounts, instance } = useMsal();
  const account = getPreferredMsalAccount(instance, accounts);

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  return (
    <div className="min-h-screen surface-ground flex align-items-center justify-content-center p-4">
      <div className="surface-card p-6 border-round shadow-2 w-full max-w-md">
        <div className="text-center mb-4">
          <i className="pi pi-lock text-6xl text-orange-500 mb-3"></i>
          <h2 className="text-900 font-bold mb-2">Authorization Required</h2>
          <p className="text-600 line-height-3 mb-0">
            You don't have the necessary permissions to access this application.
          </p>
        </div>

        <Card className="mb-4">
          <div className="text-center">
            <h3 className="text-lg font-semibold mb-3">Your Account</h3>
            <div className="flex flex-column gap-2">
              <div>
                <strong>Name:</strong> {getUserDisplayName(account)}
              </div>
              <div>
                <strong>Email:</strong> {getUserEmail(account)}
              </div>
            </div>
          </div>
        </Card>

        <div className="text-center mb-4">
          <h4 className="text-900 mb-3">Required Role</h4>
          <p className="text-600 line-height-3">
            You need at least the <strong>"Employee"</strong> role to access the
            backoffice. Please contact your administrator to request access.
          </p>
        </div>

        <div className="flex flex-column gap-3">
          <Button
            label="Sign Out"
            icon="pi pi-sign-out"
            className="p-button-outlined"
            onClick={handleLogout}
          />
        </div>

        <div className="text-center mt-4">
          <p className="text-xs text-500">
            If you believe this is an error, please contact your system
            administrator.
          </p>
        </div>
      </div>
    </div>
  );
};
